import { Injectable, signal } from '@angular/core';
import { ProductIntegrationStatus } from '../enums';

export interface ProductIntegrationNotificationState {
  status: ProductIntegrationStatus | null;
  message: string;
  isVisible: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ProductIntegrationNotificationService {
  private _state = signal<ProductIntegrationNotificationState>({
    status: null,
    message: '',
    isVisible: false
  });

  private _timer: any;

  public state = this._state.asReadonly();

  public show(status: ProductIntegrationStatus, message: string, duration = 3000): void {
    if (this._timer) {
      clearTimeout(this._timer);
    }

    this._state.set({
      status,
      message,
      isVisible: true
    });

    this._timer = setTimeout(() => {
      this.hide();
    }, duration);
  }

  public hide(): void {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }

    this._state.update(prev => ({
      ...prev,
      isVisible: false
    }));
  }
}
